<template>
    <v-container>
          <v-row class="d-flex justify-center align-center mt-3">
            <v-col cols="12" md="6">
                <v-form ref="form">
                    <v-card rounded="lg">
                        <v-container>
                            <v-row>
                                <v-col>
                                <div class="text-h5 font-weight-bold text-center">Sign Up</div>
                                <div class="text-subtitle-3 text-center">Create an account with 3 easy steps</div>
                                </v-col>
                            </v-row>
                            <v-stepper
                                v-model="step"
                                alt-labels
                                :editable="isMobileOrTablet() == false"
                                class="mt-4"
                                :items="steppers"
                                item-title="title"
                                item-value="value"
                            >
                            <template v-slot:item.1>
                                <v-card title="Basic Information" flat>
                                    <v-row dense>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                            v-model="fname"
                                            label="First Name"
                                            :rules="[formRules.required]"
                                            variant="outlined"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                            v-model="mname"
                                            label="Middle Name"
                                            variant="outlined"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                            v-model="lname"
                                            label="Last Name"
                                            :rules="[formRules.required]"
                                            variant="outlined"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-text-field
                                            v-model="suffix"
                                            label="Suffix"
                                            hint="Ex: Jr or Sr,"
                                            variant="outlined"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                            v-model="post_nominal"
                                            label="Post Nominal"
                                            hint="Ex: PhD, MIT"
                                            variant="outlined"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                            v-model="undergraduate"
                                            label="Bachelor's Degree"
                                            :rules="[formRules.required]"
                                            variant="outlined"
                                            hint="Ex: Bachelor of Science in Information Technology (BSIT), Please add (,) if you have multiple degrees"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            rows="2"
                                            >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                            v-model="graduate"
                                            label="Master's Degree"
                                            variant="outlined"
                                            hint="Ex: Master of Information Technology (MIT), Please add (,) if you have multiple degrees"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            rows="2"
                                            >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-textarea
                                            v-model="post_graduate"
                                            label="Doctoral/Professional Degree"
                                            variant="outlined"
                                            hint="Ex: Doctor of Information Technology (MIT), Please add (,) if you have multiple degrees"
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            rows="2"
                                            >
                                            </v-textarea>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                            v-model="designation"
                                            label="Designation for Document Signatory"
                                            variant="outlined"
                                            hint="Ex: Dean, Institute of Computing or BSIT, Program Chairperson or leave it blank if you no designation in academic unit/admin load, This will display under your name after you review and approved the compliance or workload."
                                            rounded="lg"
                                            type="text"
                                            color="darkGreen"
                                            >
                                            </v-text-field>
                                        </v-col>
                                        <!-- <v-col cols="12">
                                            <v-text-field
                                                v-model="core_time"
                                                label="Core Time"
                                                variant="outlined"
                                                hint="Ex: MW 8:00-5:00, TTH 7:30-5:30, F 8:00-3:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-text-field
                                                v-model="consultation_time"
                                                label="Consultation Time"
                                                variant="outlined"
                                                hint="Ex: MF 10:30-12:00"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                >
                                            </v-text-field>
                                        </v-col> -->
                                    </v-row>
                                </v-card>
                            </template>
                            <template v-slot:item.2>
                                <v-card title="Academic Information" flat>
                                    <v-row dense>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="employmentStatusId"
                                                label="Employment Status"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="employmentStatusData"
                                                item-title="description"
                                                item-value="id"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="academicRankId"
                                                label="Academic Rank"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="academicRankData"
                                                item-title="description"
                                                item-value="id"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="officeId"
                                                label="Office"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="officeData"
                                                item-title="name"
                                                item-value="id"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="programId"
                                                label="Program or Department"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="programData"
                                                item-title="name"
                                                item-value="id"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12">
                                            <v-autocomplete
                                                v-model="positionId"
                                                label="Position"
                                                :rules="[formRules.required]"
                                                variant="outlined"
                                                rounded="lg"
                                                type="text"
                                                color="darkGreen"
                                                :items="positionData"
                                                item-title="name"
                                                item-value="id"
                                                >
                                            </v-autocomplete>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </template>

                            <template v-slot:item.3>
                                <v-card title="Security Information" flat>
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="email"
                                    label="Email"
                                    :rules="[formRules.required,formRules.email, newFormRules.dnscEmail]"
                                    variant="outlined"
                                    rounded="lg"
                                    type="email"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="password"
                                    label="Password"
                                    :rules="[formRules.required]"
                                    variant="outlined"
                                    rounded="lg"
                                    :append-inner-icon="showPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                    :type="showPass ? 'text' : 'password'"
                                    @click:append-inner="showPass = !showPass"
                                    >
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                    v-model="confirmPass"
                                    label="Confirm Password"
                                    :rules="[formRules.required, value => newFormRules.passwordMatch(value, password)]"
                                    variant="outlined"
                                    rounded="lg"
                                    :append-inner-icon="showConfirmPass ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                                    :type="showConfirmPass ? 'text' : 'password'"
                                    @click:append-inner="showConfirmPass = !showConfirmPass"
                                    >
                                    </v-text-field>
                                </v-col></v-card>
                            </template>
                            </v-stepper>
                            <v-row dense class="mt-2">
                                <v-col cols="12">
                                    <v-btn
                                    :disabled="step != 3"
                                    @click="validateForm()"
                                    :loading="loading"
                                    color="darkGreen"
                                    height="40px"
                                    rounded="lg"
                                    width="100%">
                                        Sign up
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-divider class="mt-4 mb-4 mx-4"></v-divider>
                                <v-col cols="12">
                                    <div class="text-subtitle-1 text-center">Already have an account? <router-link
                                        to="/"
                                    >Login</router-link></div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card>
                </v-form>
            </v-col>
          </v-row>
    </v-container>

    <v-dialog v-model="confirmRegister" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2">Are you sure you want proceed?</div>
                <div class="font-weight-light mt-2">Note: Please make sure if all information are correct</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmRegister = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="signUp()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <v-dialog v-model="successDialog" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <v-img src="../assets/review.png"></v-img>
                <div class="font-weight-bold mt-2 text-center" style="text-transform: uppercase;">You are successfully registered!</div>
                <div class="font-weight-light mt-2 text-center">As of the moment, your account is subject for verification by the admin. You can contact systems administrators or the VPAA office for a quick response.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="successDialog = false" variant="outlined">
                Close
            </v-btn>
            <v-btn router to="/" color="darkGreen" variant="elevated">
                Back to Login Page
            </v-btn>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    data(){
        return{
            fname: null,
            mname: null,
            lname: null,
            suffix: null,
            post_nominal: null,
            undergraduate: null,
            graduate: null,
            post_graduate: null,
            employmentStatusId: null,
            academicRankId: null,
            officeId: null,
            programId: null,
            positionId: null,
            designation: null,
            core_time: null,
            consultation_time: null,

            email: null,
            password: null,
            confirmPass: null,

            showPass: false,
            showConfirmPass: false,

            loading: false,
            step: null,
            confirmRegister: false,

            steppers: [
                { title: 'Step 1', value: 1},
                { title: 'Step 2', value: 2},
                { title: 'Step 3', value: 3},
            ],

            employmentStatusData: [],
            academicRankData: [],
            officeData: [],
            programData: [],
            positionData: [],

            successDialog: false,

            newFormRules: {
                passwordMatch: (value, password) => value === password || 'Passwords must match',
                dnscEmail: (value) => /.+@dnsc\.edu\.ph$/.test(value) || 'Must be a DNSC Email',
            },
        }
    },
    methods: {
        async initForm(){
            await axios.get(process.env.VUE_APP_SERVER_URL + '/employment-status')
            .then(res => {
                this.employmentStatusData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/academic-rank')
            .then(res => {
                this.academicRankData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/offices/getAllInstitute')
            .then(res => {
                this.officeData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/programs')
            .then(res => {
                this.programData = res.data
            });

            await axios.get(process.env.VUE_APP_SERVER_URL + '/position')
            .then(res => {
                this.positionData = res.data
            });
        },
        async validateForm(){
            const { valid } = await this.$refs.form.validate()
            if(valid){
                this.confirmRegister = true
            }   
        },
        async signUp(){
            const { showSnackbar } = useSnackbar()

            this.loading = true
            let formData = {
                userDetails: {
                    fname: this.fname,
                    mname: this.mname,
                    lname: this.lname,
                    suffix: this.suffix,
                    post_nominal: this.post_nominal,
                    undergraduate: this.undergraduate,
                    graduate: this.graduate,
                    post_graduate: this.post_graduate,
                    employmentStatusId: this.employmentStatusId,
                    academicRankId: this.academicRankId,
                    officeId: this.officeId,
                    programId: this.programId,
                    positionId: this.positionId,
                    designation: this.designation,
                    core_time: this.core_time,
                    consultation_time: this.consultation_time
                },
                userSec: {
                    email: this.email,
                    password: this.password
                }
            }
            try {
                await axios.post(process.env.VUE_APP_SERVER_URL + '/auth/registerUser', formData)
                .then(res => {
                    if(res.data.status == 409){
                        this.loading = false
                        this.confirmRegister = false
                        showSnackbar('This email you entered is already been used')
                    }
                    else if(res.data.status == 400){
                        this.loading = false,
                        this.confirmRegister = false
                        showSnackbar('There is an error during registration. Please go to the admin and ask assistance')
                    }
                    else{
                        this.$refs.form.reset()
                        this.step = 1
                        this.loading = false
                        this.confirmRegister = false
                        this.successDialog = true
                    }
                });
            } catch (error) {
                console.log(error)
            }
        }
    },
    mounted(){
        this.initForm()
    }
})
</script>

<style  scoped>

</style>